import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-overlay-panel',
  templateUrl: './overlay-panel.component.html',
  styleUrls: ['./overlay-panel.component.scss']
})
export class OverlayPanelComponent {
  @Input()
  @HostBinding('class.full-width')
  public fullWidth = false;

  @Input()
  @HostBinding('class.is-showing')
  public isShowing = false;
}
